import { styled } from "@mui/material/styles";

const CardStyles = styled("div")(
  ({ theme }) => `

    @media (min-width: 600px) {
      display: none;
    }

    .card-container{
  position: relative;
    gap: 10px;
    display: flex;
    flex-direction: column;
        width: calc(100vw - 40px);
        background-color: #F0F0F0;
    }

    .card-box{
    background-color: ${theme.palette.customColor.white};
    padding: 13.5px 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    }

    .label {
    font-family: Lexend;
    font-weight: 400;
    font-size: 10px;
    color: ${theme.palette.customColor.secondarySecond};
    text-transform: capitalize;
    }

    .value{
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
    padding-left: 6px;
    }

    .content {
    display: flex;
    align-items: center;
    }

    .order-no{
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.secondary.main};
    }

    .show-more {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.secondary.main};
    }

    .show-more-section{
    border-top: 1px solid ${theme.palette.customColor.secondaryFirst};
    padding-top:6px;
    margin-top:6px;
    display: flex;
    justify-content: space-between;
    align-items: end;
    }

    .down-icon{
    padding: 0px;
    margin-bottom: -8px;
    }

    .details{
    background-color: #F0F0F066;
    padding:12px;
    margin-top:6px;

      .title{
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      color: ${theme.palette.customColor.placeholder};
      text-transform: uppercase;
      }

      .product{
      padding-top: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid ${theme.palette.customColor.secondaryThird};
      display: flex;
      gap: 12px;
      flex-direction: column;
      }

      .content-boxes{
      display: flex;
      gap: 5px;
      flex-direction: column;
      }

      .total-text {
      font-family: Lexend;
      font-weight: 500;
      font-size: 14px;
      color: ${theme.palette.customColor.secondarySecond};
      }

      .total-value{
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      color: ${theme.palette.primary.main};
      }

      .total-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;
      }
    
    }

    .pagination-container {
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    row-gap:10px;
    background-color: #F0F0F0;
    }

    .pagesize{
    display: flex;
    align-items: center;
    gap: 5px;
    }

     .select-input {
      height: 30px;
      width: 70px;
      background-color: ${theme.palette.customColor.white};
      & .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.customColor.secondaryThird};
      }
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.customColor.secondaryThird};
      }
      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.customColor.secondaryThird};
      }
    }
}
.mobile-view-deatls {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.deatils-value {
  font-family: Lexend;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: ${theme.palette.primary.main};
}      
`
);

export { CardStyles };

